export default __webpack_public_path__ + "static/media/carlwhizzer.426fd93a.png";